// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  VirtualAdVehiclesAreaId,
  VirtualAdVehiclesAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import { VirtualAdVehiclesAreaNavigation } from './VirtualAdVehiclesAreaNavigation'

const LazyVirtualAdVehiclesComponent = lazy(
  () => import('./VirtualAdVehiclesArea'),
)

const VirtualAdVehiclesComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVirtualAdVehiclesComponent />
  </SuspenseLoadingWrapper>
)

export const VirtualAdVehiclesArea = {
  id: VirtualAdVehiclesAreaId,
  requiredRight: BoumRight.AREA_AD_FLEET_MAP,
  NavigationComponent: VirtualAdVehiclesAreaNavigation,
  route: {
    path: VirtualAdVehiclesAreaRoutes.route,
    component: VirtualAdVehiclesComponent,
  },
}
